<template>
  <div class="activity-container">
    <div class="content-title">设备管理</div>
    <MyForm class="search-form" :formOptions="queryForm" :inline="true">
      <template #addBtn>
        <MyButton icon="Plus" @click="dialogVisible = true" v-auth="(val) => val<=0">添加设备</MyButton>
      </template>
    </MyForm>
    <MyTable :table-options="tableOptions" border max-height="60vh">
      <template #isOnline="{ row }">
        <el-switch v-model="row.isOnline" @change="click_switch(row)"></el-switch>
      </template>
      <template #handler="{ row }">
        <MyButton link icon="Edit" @click="click_edit(row)">编辑</MyButton>
        <MyButton v-auth="(val) => val<=0" link icon="View" @click="click_view(row)">查看appKey</MyButton>
      </template>
    </MyTable>
    <MyPagination :params="paginationParams" :total="total" @get-list="getUserList" ref="paginationRef" />

    <!-- 添加设备 -->
    <Dialog width="30%" v-model="dialogVisible" title="添加设备" top="5vh" @closed="resetForm()">
      <el-form ref="formRef" :model="formData" class="myform" label-width="auto">
        <el-form-item v-auth="(val) => val<=0" label="设备名称:" prop="userName" :rules="[{ required: true, message: '请输入设备名称', trigger: 'blur' }]">
          <el-input v-model="formData.userName"></el-input>
        </el-form-item>
        <el-form-item v-auth="(val) => val<=0" label="所属单位:" prop="organizationId" :rules="[{ required: true, message: '请选择所属单位', trigger: 'change' }]">
          <el-select @change="getActivityList" v-model="formData.organizationId" placeholder="">
            <el-option v-for="item in unitList" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.id" label="当前二维码:" prop="deviceCodeActivity" :rules="[{ required: true, message: '请选择当前二维码', trigger: 'change' }]">
          <el-select @change="activityChange" v-model="formData.deviceCodeActivity" placeholder="">
            <el-option v-for="item in activityList" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.id" label=" ">
          <span class="tip">可在此下拉选择设备端显示的二维码</span>
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="click_confirm">确定</el-button>
      </div>
    </Dialog>

    <!-- appKey -->
    <Dialog width="30%" v-model="appkeyVisible" title="appKey" top="15vh" @closed="resetForm()" :fullscreen="false">
      <el-form class="appkey-dialog" label-width="auto">
        <el-form-item label="appKey：" prop="appKey">
          <el-input v-model="formData.appKey" readonly placeholder=""></el-input>
          <el-button link type="primary" v-copy="formData.appKey">点击复制</el-button>
        </el-form-item>
        <el-form-item label="secretKey：" prop="secretKey">
          <el-input v-model="formData.secretKey" readonly placeholder=""></el-input>
          <el-button link type="primary" v-copy="formData.secretKey">点击复制</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import organizationApi from "@/api/organization";
import { dayjs } from "element-plus";
import { local } from "@/utils/storage.js";
import { cloneDeep } from "lodash-es";
import activityApi from "@/api/activity";

const unitList = ref([]);
const getUnitList = () => {
  organizationApi.getUnitList({
    SkipCount: 0,
    MaxResultCount: 1000,
  }).then((res) => {
    unitList.value = res.data.items
  })
}
getUnitList();
const activityList = ref([]);
const getActivityList = (val) => {
  formData.value.deviceCodeActivity = null;
  activityApi.getActivityList({
    SkipCount: 0,
    MaxResultCount: 1000,
    OrganizationId: val
  }).then((res) => {
    activityList.value = res.data.items.map(item => {
      return {
        type: 1,
        ...item
      }
    })
    activityList.value.unshift({
      type: 0,
      name: unitList.value.find(item => item.id === val).name,
      id: val
    })
  })
}

const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "设备名称:",
      prop: "userName",
      attrs: {
        placeholder: "请输入关键词",
      },
    },
    {
      type: "Date",
      label: "日期:",
      prop: "CreationTime",
      attrs: {
        placeholder: "请选择",
        valueFormat: "YYYY-MM-DD",
      },
    },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
        },
        events: {
          click(formData) {
            Object.assign(paginationParams, formData);
          },
        },
      },
      {
        type: "Slot",
        slot_name: "addBtn",
      },
    ]
  ],
});

const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", minWidth: 60 },
    { label: "设备名称", prop: "userName" },
    { label: "添加日期", prop: "creationTime" },
    { label: "所属组织", prop: "organizationName"},
    { label: "当前二维码", prop: "deviceCodeActivityName"},
    { label: "是否启动", type: "slot", slot_name: "isOnline" },
    { label: "操作", type: "slot", slot_name: "handler", minWidth: 150 },
  ],
  tableData: [],
});

// 分页
const paginationParams = reactive({
  Type: 99,
  OrganizationId: local.get("type")<=0 ? "" : local.get("organizationId"),
  Name: "",
  CreationTime: "",
})
const paginationRef = ref(null);
const total = ref(0);
const getUserList = (params = paginationRef.value.getList_params) => {
  organizationApi.getUserList(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items.map(item=>{
      item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD");
      item.deviceCodeActivityName = item.deviceCodeId ? item.deviceCodeType == 1 ? item.deviceCodeActivityName : item.organizationName : null;
      return item;
    });
  })
}

const dialogVisible = ref(false);
const formData = ref({
  userName: "",
  organizationId: "",
})
const formRef = ref(null);
const click_confirm = () => {
  formRef.value.validate(async(valid) => {
    if (valid) {
      formData.value.type = 99;
      formData.value.loginUser = formData.value.loginUser || "";
      formData.value.password = formData.value.password || "";
      if(formData.value.id){
        await organizationApi.editUser(formData.value)
        if(formData.value.organizationId == oldOrganizationId.value && formData.value.deviceCodeId){
          await activityApi.editBindActivity({
            id: formData.value.deviceCodeId,
            deviceId: formData.value.id,
            type: formData.value.deviceCodeType,
            activityID: formData.value.deviceCodeActivity
          })
        }else{
          await activityApi.bindActivity({
            deviceId: formData.value.id,
            type: 0,
          });
        }
      }else{
        let res = await organizationApi.addUser(formData.value)
        await activityApi.bindActivity({
          deviceId: res.data.id,
          type: 0,
        });
      }
      ElMessage.success(`${formData.value.id ? "编辑" : "新增"}成功`);
      dialogVisible.value = false;
      getUserList();
    }
  })
}

const activityChange = (val) => {
  formData.value.deviceCodeType = activityList.value.find(item=>item.id==val).type;
}

const oldOrganizationId = ref(null);
const click_edit = (row) => {
  oldOrganizationId.value = row.organizationId;
  dialogVisible.value = true;
  getActivityList(row.organizationId);
  formData.value = cloneDeep(row);
  formData.value.deviceCodeActivity = formData.value.deviceCodeId ? formData.value.deviceCodeType == 1 ? formData.value.deviceCodeActivity : formData.value.organizationId : null;
}
//仅管理员查看
const appkeyVisible = ref(false);
const click_view = (row) => {
  appkeyVisible.value = true;
  formData.value = cloneDeep(row);
}

const click_switch = (row) => {
  row.loginUser = row.loginUser || "";
  row.password = row.password || "";
  organizationApi.editUser(row).then((res) => {
    ElMessage.success("操作成功");
  })
}

const resetForm = () => {
  formData.value = {
    userName: "",
    organizationId: "",
  }
}

</script>

<style lang="scss" scoped>
.myform{
  padding: 20px 40px;
}
.tip{
  color: #f00;
}
.appkey-dialog{
  :deep(){
    padding: 20px;
    .el-input{
      flex: 1;
      margin-right: 10px;
    }
  }
}
</style>